module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/gallery/tmb_gallery6-2405357f25ae00613293068ea5446003.jpg";